import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import { Dialog } from "./Dialog";
import { IGifInfo } from "services/types";

import { apiMain, apiNiches } from "services";
import { NicheSelector } from "./NicheSelector";

import "./EditNichesDialog.scss";

export const EditNichesDialog = (props: {
  gifId: string;
  onClose: () => void;
}): JSX.Element => {
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    apiMain.fetchGifById(props.gifId).then((res: IGifInfo) => {
      setSelected(res.gif.niches);
      console.debug(`Gif niches: ${res.gif.niches}`);
    });
  }, [props.gifId]);

  const handleChange = (ids: string[]): void => {
    setSelected(ids);
  };

  const handleSave = async () => {
    try {
      await apiNiches.setGifNiches({
        gifId: props.gifId,
        nicheIds: selected,
      });

      toast.success("Gif niches updated.");

      props.onClose();
    } catch (e) {
      console.error(`Could not set gif niches: ${e}`);
      toast.error("Could not save niches, please try again.");
    }
  };

  const buttons = () => (
    <button className="button primary" onClick={handleSave}>Save</button>
  );

  return (
    <Dialog
      onClose={props.onClose}
      title="Change gif niches"
      className="editNichesDialog"
      buttons={buttons()}
    >
      <NicheSelector
        selected={selected}
        onChange={handleChange}
      />
    </Dialog>
  );
};
